"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsListRequest = void 0;
var NewsListRequest = /** @class */ (function () {
    function NewsListRequest() {
    }
    return NewsListRequest;
}());
exports.NewsListRequest = NewsListRequest;
;
//# sourceMappingURL=newsList.request.js.map